import styled from '@emotion/styled'

const PetitionsSection = styled.section`
  .inner {
    margin-bottom: 60px;
    .petitions_title {
      padding-top: 4rem;
      padding-bottom: 2rem;
      border-bottom: 2px solid #ccc;
      > span {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
`

export { PetitionsSection }
